import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function HotMovies() {
  const hotMovies = movies.filter((m) => m.hot);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-500">
              <i className="ri-fire-line text-white text-sm"></i>
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
                热门大片
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                大家正在看的热门电影
              </p>
            </div>
          </div>
          <a
            href="/category/dongzuo"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE("/category/dongzuo");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {hotMovies.map((movie, index) => (
            <div key={movie.id} className="relative">
              {index < 3 && (
                <div className="absolute -top-2 -left-2 z-10 w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold shadow-sm">
                  {index + 1}
                </div>
              )}
              <MovieCard movie={movie} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}